import { render, staticRenderFns } from "./RecogAlertEdit.vue?vue&type=template&id=52cf2f6e"
import script from "./RecogAlertEdit.vue?vue&type=script&lang=js"
export * from "./RecogAlertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports